import { DEAL_LABELS } from "./common";

export const DOCUMENT_SCHEMA_VERSION = "1.0";

export const UNDO_REDO_STACK_LENGTH = 10;

export const MAX_COLUMN_ALLOWED = 20;

export const DOCUMENT_FETCH_TIMEOUT = 120000;

export const UNDO_REDO_STACK_TIME_LIMIT = 1000;

export const DOCX_FILETYPE =
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

export const BUTTONS = [
  {
    id: "add-text",
    label: "Text",
    icon: ["far", "text-height"],
  },
  {
    id: "add-table",
    label: "Table",
    icon: ["far", "table"],
  },
  {
    id: "add-dealtable",
    label: DEAL_LABELS["deal-table-label"],
    icon: ["far", "badge-percent"],
  },
  {
    id: "add-quotetable-placeholder",
    label: DEAL_LABELS["deal-table-label"],
    icon: ["far", "badge-percent"],
  },
  {
    id: "add-image",
    label: "Image",
    icon: ["far", "image"],
  },
  {
    id: "add-page-break",
    label: "Page Break",
    icon: ["far", "page-break"],
  },
  {
    id: "add-line-space",
    label: "Empty space",
    icon: ["far", "arrows-v"],
  },
  {
    id: "add-signature-space",
    label: "Signature",
    icon: ["far", "signature"],
  },
  {
    id: "add-google-sheet",
    label: "Google Sheet",
    icon: ["fas", "file-spreadsheet"],
  },
  {
    id: "add-payment-button",
    label: "Payment button",
    icon: ["far", "credit-card-front"],
    isBeta: true,
  },
];

export const DOCUMENT_STYLINGS = [
  {
    id: "add-cover-page",
    label: "Cover page",
    icon: ["far", "file-image"],
  },
];

export const DOCUMENT_SIGNATURE_CONTEXT = {
  signature: { icon: ["far", "signature"], label: "Signature" },
  // signerInitials: { icon: ["far", "signature"], label: "Signer Initials" },
  name: { icon: ["far", "user"], label: "Name" },
  date: { icon: ["far", "calendar-alt"], label: "Date" },
  // signingTitle: { icon: ["far", "signature"], label: "Signing Title" },
  // signingCompany: { icon: ["far", "signature"], label: "Signing Company" },
};

export const DEALTABLE_COLUMNS = [
  {
    name: "product_name",
    text: "Product name",
    currency: false,
  },
  {
    name: "sku",
    text: "SKU",
    currency: false,
  },
  {
    name: "ext_base_price",
    text: "Price",
    currency: true,
  },
  {
    name: "net_price",
    text: "Net price",
    currency: true,
  },
];

export const DOCUMENT_MODE = {
  PREVIEW: "PREVIEW",
  DOCUMENT: "DOCUMENT",
  TEMPLATE: "TEMPLATE",
  UPLOADED_DOCUMENT: "UPLOAD_DOCUMENT",
  TEMPLATE_DOCUMENT: "TEMPLATE_DOCUMENT",
};

export const DRAFT_ENTITY = {
  DELETED: "DELETED",
  INSERTED: "INSERTED",
  COMMENTS: "COMMENTS",
  NOTES: "NOTES",
  DYNAMICFIELD: "DYNAMICFIELD",
  MENTION: "mention",
  LINK: "LINK",
};

export const ADD_COMPONENTS = {
  DOCUMENT: [
    "add-text",
    "add-table",
    "add-dealtable",
    "add-image",
    "add-page-break",
    "add-line-space",
    // "add-header-footer",
    "add-cover-page",
    "add-signature-space",
    "add-google-sheet",
    "add-payment-button",
  ],
  TEMPLATE: [
    "add-text",
    "add-table",
    "add-quotetable-placeholder",
    "add-image",
    "add-page-break",
    "add-line-space",
    // "add-header-footer",
    "add-cover-page",
    "add-signature-space",
    "add-payment-button",
  ],
};

export const COMPONENT_FEATURE = {
  PREVIEW: {},
  DOCUMENT: {
    addDealTableComponent: true,
    addImageComponent: true,
    addNote: true,
    addTableComponent: true,
    addTextComponent: true,
    allowDiff: true,
    allowUndo: true,
    deleteSection: true,
    editSection: true,
    hyperlinkButton: true,
  },
  TEMPLATE: {
    addImageComponent: true,
    addTableComponent: true,
    addTextComponent: true,
    allowUndo: true,
    createClause: true,
    createClauseOption: true,
    deleteSection: true,
    dynamicFieldButton: true,
    editSection: true,
    lockSection: true,
    hyperlinkButton: true,
  },
  UPLOADED_DOCUMENT: {},
  TEMPLATE_DOCUMENT: {
    addDealTableComponent: true,
    addImageComponent: true,
    addNote: true,
    addTableComponent: true,
    addTextComponent: true,
    allowDiff: true,
    allowUndo: true,
    deleteSection: true,
    editSection: true,
  },
};

export const TEMPLATE_SHOW_CLAUSES_FOR_COMPONENT_TYPE = ["HTML"];

export const TEMPLATE_SHOW_CLAUSE_OPTIONS_FOR_COMPONENT_TYPE = ["HTML"];

export const PRODUCT_CONFIG_TYPES = [
  "Add-on",
  "Bundle",
  "Standalone",
  "Service",
];

export const DOCUMENT_EXTRACTION = {
  TEMPLATE: [],
  DOCUMENT: ["comments", "notes"],
  TEMPLATE_DOCUMENT: ["notes"],
  UPLOADED_DOCUMENT: ["deleted", "inserted", "comments"],
};

export const ALLOWED_ENTITY_DRAFT_TO_HTML = {
  TEMPLATE: ["DYNAMICFIELD"],
  DOCUMENT: ["DYNAMICFIELD"],
  TEMPLATE_DOCUMENT: ["DYNAMICFIELD"],
  UPLOADED_DOCUMENT: [],
  PREVIEW: [],
  DRAFTJSNOTE: ["mention"],
};

// add entity in allowed conversion
// for template add it from other configs
Object.keys(DOCUMENT_EXTRACTION).forEach(mode => {
  const allowedEntity = DOCUMENT_EXTRACTION[mode];
  allowedEntity.forEach(entity => {
    const draftEntity = DRAFT_ENTITY[entity.toUpperCase()];
    if (
      draftEntity &&
      ALLOWED_ENTITY_DRAFT_TO_HTML[mode] &&
      ALLOWED_ENTITY_DRAFT_TO_HTML[mode].findIndex(e => e === draftEntity) ===
        -1
    ) {
      ALLOWED_ENTITY_DRAFT_TO_HTML[mode].push(draftEntity);
    }
  });
});

Object.keys(COMPONENT_FEATURE).forEach(mode => {
  // check if highlight  note is allowed for this mode
  if (
    COMPONENT_FEATURE[mode] &&
    COMPONENT_FEATURE[mode].addNote &&
    ALLOWED_ENTITY_DRAFT_TO_HTML[mode].findIndex(
      e => e === DRAFT_ENTITY.NOTES,
    ) === -1
  ) {
    ALLOWED_ENTITY_DRAFT_TO_HTML[mode].push(DRAFT_ENTITY.NOTES);
  }

  // check if inserted and deleted feature is allowed
  if (COMPONENT_FEATURE[mode] && COMPONENT_FEATURE[mode].allowDiff) {
    if (
      ALLOWED_ENTITY_DRAFT_TO_HTML[mode].findIndex(
        e => e === DRAFT_ENTITY.INSERTED,
      ) === -1
    ) {
      ALLOWED_ENTITY_DRAFT_TO_HTML[mode].push(DRAFT_ENTITY.INSERTED);
    }
    if (
      ALLOWED_ENTITY_DRAFT_TO_HTML[mode].findIndex(
        e => e === DRAFT_ENTITY.DELETED,
      ) === -1
    ) {
      ALLOWED_ENTITY_DRAFT_TO_HTML[mode].push(DRAFT_ENTITY.DELETED);
    }
    if (
      ALLOWED_ENTITY_DRAFT_TO_HTML[mode].findIndex(
        e => e === DRAFT_ENTITY.LINK,
      ) === -1
    ) {
      ALLOWED_ENTITY_DRAFT_TO_HTML[mode].push(DRAFT_ENTITY.LINK);
    }
  }
});

export const DEALTABLE_VIEW = [
  {
    type: "NORMAL_VIEW",
    label: "Normal View",
  },
  {
    type: "GROUPED_VIEW",
    label: "Grouped View",
  },
  {
    type: "GROUPED_SUMMARY",
    label: "Group Summary View",
  },
];

export const DEALTABLE_GROUPVIEW_HEADERS = [
  { key: "group_by_value", label: "Group name", currency: false, total: false },
  { key: "group_total", label: "Group total", currency: true, total: true },
  {
    key: "discount_percent",
    label: "Group discount(%)",
    currency: false,
    total: false,
  },
  {
    key: "discountAmount",
    label: "Group discount",
    currency: true,
    total: false,
  },
  {
    key: "discountedGroupTotal",
    label: "Discounted group total",
    currency: true,
    total: true,
  },
];

// "DOCUMENT_STATUS_CONFIG" for showing the document status label
// in document details page based on current doc status
export const DOCUMENT_STATUS_CONFIG = [
  { seqNo: 1, stage: "Draft", className: "" },
  { seqNo: 2, stage: "Internal Review", className: "" },
  { seqNo: 3, stage: "Customer Review", className: "" },
  { seqNo: 4, stage: "Signature", className: "" },
];

export const DOCUMENT_STATUS_HASH_MAP = {
  DRAFT: "DRAFT",
  PENDING_APPROVAL: "REVIEW PENDING",
  REJECTED: "INTERNAL REJECTED",
  APPROVED: "CUSTOMER REVIEW",
  SENT_TO_CLIENT: "SENT TO CLIENT",
  DOCUMENT_CLIENT_APPROVED: "CLIENT APPROVED",
  DOCUMENT_CLIENT_REJECTED: "CLIENT REJECTED",
  PREPARE_FOR_SIGNATURE: "CUSTOMER REVIEW",
  SIGNATURE_PENDING: "SIGNATURE PENDING",
  DOCUMENT_CLIENT_SIGNED: "SIGNED",
};

export const DOCUMENT_HYPERLINK_BOX = {
  newUrlHeader: "Insert Hyperlink",
  changeUrlHeader: "Modify Hyperlink",
  urlInputLabel: "Link URL:",
  cancelBtnText: "Cancel",
  insertLinkText: "Insert link",
  modifyLinkText: "Modify link",
};

export const DOCUMENT_COMPONENT_TYPES = {
  HTML: "HTML",
  TABLE: "Table",
  IMAGE: "Image",
  DEAL_TABLE: "DealTable",
  QUOTE_TABLE: "QuoteTable",
  QUOTE_TABLE_WRAPPER: "QuoteTableWrapper",
  EMPTY_CONTAINER: "EmptyContainer",
  EMPTY_SIGNATURE_CONTAINER: "Signature",
  GOOGLE_SHEET: "GoogleSheet",
  PAGE_BREAK: "PageBreak",
  LINE_SPACE: "LineSpace",
  HEADER_FOOTER: "HeaderFooter",
  COVERPAGE: "CoverPage",
  HEADER: "header",
  FOOTER: "footer",
  STRIPE_PAYMENT_BUTTON: "StripePayment",
};

export const DOC_COMPONENT_TYPES_PLACEHOLDER_TEXT = {
  [DOCUMENT_COMPONENT_TYPES.HTML]: "Text",
  [DOCUMENT_COMPONENT_TYPES.TABLE]: "Table",
  [DOCUMENT_COMPONENT_TYPES.IMAGE]: "Image",
  [DOCUMENT_COMPONENT_TYPES.DEAL_TABLE]: DEAL_LABELS["deal-table-label"],
  [DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE]: "Quote table",
  [DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE_WRAPPER]:
    DEAL_LABELS["deal-table-label"],
  [DOCUMENT_COMPONENT_TYPES.EMPTY_CONTAINER]: "Empty container",
  [DOCUMENT_COMPONENT_TYPES.EMPTY_SIGNATURE_CONTAINER]: "signature",
  [DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET]: "Google Sheet",
  [DOCUMENT_COMPONENT_TYPES.PAGE_BREAK]: "Page break",
  [DOCUMENT_COMPONENT_TYPES.LINE_SPACE]: "Empty space",
  [DOCUMENT_COMPONENT_TYPES.HEADER_FOOTER]: "Header and Footer",
  [DOCUMENT_COMPONENT_TYPES.COVERPAGE]: "Cover page",
  [DOCUMENT_COMPONENT_TYPES.STRIPE_PAYMENT_BUTTON]: "Payment button",
};

export const DROP_COMPONENT_PLACEHOLDER_TEXT = {
  [DOCUMENT_COMPONENT_TYPES.HTML]: "text",
  [DOCUMENT_COMPONENT_TYPES.TABLE]: "table",
  [DOCUMENT_COMPONENT_TYPES.IMAGE]: "image",
  [DOCUMENT_COMPONENT_TYPES.DEAL_TABLE]: "deal table",
  [DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE]: "quote table",
  [DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE_WRAPPER]: "quote table wrapper",
  [DOCUMENT_COMPONENT_TYPES.EMPTY_SIGNATURE_CONTAINER]: "signature",
  [DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET]: "google sheet",
  [DOCUMENT_COMPONENT_TYPES.PAGE_BREAK]: "page break",
  [DOCUMENT_COMPONENT_TYPES.LINE_SPACE]: "empty space",
  [DOCUMENT_COMPONENT_TYPES.STRIPE_PAYMENT_BUTTON]: "Payment button",
};

export const DOCUMENT_LINE_SPACER_DATA = [
  { id: "1x", label: "1x", length: "50", unit: "px" },
  { id: "2x", label: "2x", length: "100", unit: "px" },
  { id: "3x", label: "3x", length: "150", unit: "px" },
];

export const APPROXIMATE_PAGE_BREAK_DATA = {
  STANDARD_PAGE_SIZE: 1123,
  DEFAULT_GAP: 20,
  EMPTY_SPACE_HEADER_FOOTER: 60,
  TWO_COMPS_GAP: 15,
};

export const DOCUMENT_TOASTR_MESSAGE = {
  DOCUMENT_RENAME: "Your document name has been updated successfully",
  CANCEL_ONE_SPAN: "Document moved to Drafts successfully!",
};

export const HEADER_FONT_SIZES = {
  "header-one": 36,
  "header-two": 30,
  "header-three": 24,
  "header-four": 18,
};

export const FONT_SIZE_OPTIONS = {
  FONTSIZE_EIGHT: {
    fontSize: "8px",
  },
  FONTSIZE_NINE: {
    fontSize: "9px",
  },
  FONTSIZE_TEN: {
    fontSize: "10px",
  },
  FONTSIZE_ELEVEN: {
    fontSize: "11px",
  },
  FONTSIZE_TWELVE: {
    fontSize: "12px",
  },
  FONTSIZE_FOURTEEN: {
    fontSize: "14px",
  },
  FONTSIZE_SIXTEEN: {
    fontSize: "16px",
  },
  FONTSIZE_EIGHTEEN: {
    fontSize: "18px",
  },
  FONTSIZE_TWENTYFOUR: {
    fontSize: "24px",
  },
  FONTSIZE_THIRTY: {
    fontSize: "30px",
  },
  FONTSIZE_THIRTYSIX: {
    fontSize: "36px",
  },
  FONTSIZE_FOURTYEIGHT: {
    fontSize: "48px",
  },
  FONTSIZE_SIXTY: {
    fontSize: "60px",
  },
  FONTSIZE_SEVENTYTWO: {
    fontSize: "72px",
  },
  FONTSIZE_NINTYSIX: {
    fontSize: "96px",
  },
  FONTSIZE_ONEHUNDREDTWENTY: {
    fontSize: "120px",
  },
  FONTSIZE_ONEHUNDREDFOURTYFOUR: {
    fontSize: "144px",
  },
};

export const FONT_SIZE_OPTIONS_MAP = {
  "8px": "8",
  "9px": "9",
  "10px": "10",
  "11px": "11",
  "12px": "12",
  "14px": "14",
  "16px": "16",
  "18px": "18",
  "24px": "24",
  "30px": "30",
  "36px": "36",
  "48px": "48",
  "60px": "60",
  "72px": "72",
  "96px": "96",
  "120px": "120",
  "144px": "144",
};

export const FONT_COLOR_OPTIONS = {
  FONTCOLOR_ffffff: {
    color: "#ffffff",
  },
  FONTCOLOR_000000: {
    color: "#000000",
  },
  FONTCOLOR_333333: {
    color: "#333333",
  },
  FONTCOLOR_888888: {
    color: "#888888",
  },
  FONTCOLOR_3333ff: {
    color: "#3333ff",
  },
  FONTCOLOR_66ccff: {
    color: "#66ccff",
  },
  FONTCOLOR_ff001c: {
    color: "#ff001c",
  },
  FONTCOLOR_faff00: {
    color: "#faff00",
  },
  FONTCOLOR_9cd326: {
    color: "#9cd326",
  },
  FONTCOLOR_427d50: {
    color: "#427d50",
  },
  FONTCOLOR_72c9c5: {
    color: "#72c9c5",
  },
  FONTCOLOR_9dacbb: {
    color: "#9dacbb",
  },
  FONTCOLOR_9795ff: {
    color: "#9795ff",
  },
  FONTCOLOR_7053c9: {
    color: "#7053c9",
  },
  FONTCOLOR_740e0e: {
    color: "#740e0e",
  },
  FONTCOLOR_ff0078: {
    color: "#ff0078",
  },
  FONTCOLOR_795449: {
    color: "#795449",
  },
  FONTCOLOR_e26d3f: {
    color: "#e26d3f",
  },
  FONTCOLOR_f1cb45: {
    color: "#f1cb45",
  },
  FONTCOLOR_bea938: {
    color: "#bea938",
  },
  FONTCOLOR_99218d: {
    color: "#99218d",
  },
  FONTCOLOR_8c39f0: {
    color: "#8c39f0",
  },
  FONTCOLOR_0a269a: {
    color: "#0a269a",
  },
  FONTCOLOR_1f3e57: {
    color: "#1f3e57",
  },
  FONTCOLOR_def8f6: {
    color: "#def8f6",
  },
  FONTCOLOR_cfd4d9: {
    color: "#cfd4d9",
  },
  FONTCOLOR_c12928: {
    color: "#c12928",
  },
};

export const FONT_FAMILY_OPTIONS = {
  FONTFAMILY_ARIAL: {
    fontFamily: "Arial",
  },
  FONTFAMILY_BASKERVILLE: {
    fontFamily: "Baskerville",
  },
  FONTFAMILY_COURIERNEW: {
    fontFamily: "Courier New",
  },
  FONTFAMILY_EBGARAMOND: {
    fontFamily: "EB Garamond",
  },
  FONTFAMILY_GEORGIA: {
    fontFamily: "Georgia",
  },
  FONTFAMILY_HELVETICA: {
    fontFamily: "Helvetica",
  },
  FONTFAMILY_INTER: {
    fontFamily: "Inter",
  },
  FONTFAMILY_KALAM: {
    fontFamily: "Kalam",
  },
  FONTFAMILY_LATO: {
    fontFamily: "Lato",
  },
  FONTFAMILY_MONTSERRAT: {
    fontFamily: "Montserrat",
  },
  FONTFAMILY_OPENSANS: {
    fontFamily: "Open Sans",
  },
  FONTFAMILY_OSWALD: {
    fontFamily: "Oswald",
  },
  FONTFAMILY_PLAYFAIRDISPLAY: {
    fontFamily: "Playfair Display",
  },
  FONTFAMILY_POPPINS: {
    fontFamily: "Poppins",
  },
  FONTFAMILY_RALEWAY: {
    fontFamily: "Raleway",
  },
  FONTFAMILY_ROBOTO: {
    fontFamily: "Roboto",
  },
  FONTFAMILY_ROBOTOCONDENSED: {
    fontFamily: "Roboto Condensed",
  },
  FONTFAMILY_TIMESNEWROMAN: {
    fontFamily: "Times New Roman",
  },
  FONTFAMILY_TITILLIUMWEB: {
    fontFamily: "Titillium Web",
  },
};

export const FONT_FAMILY_OPTIONS_MAP = {
  Arial: "FONTFAMILY_ARIAL",
  Baskerville: "FONTFAMILY_BASKERVILLE",
  "Courier New": "FONTFAMILY_COURIERNEW",
  "EB Garamond": "FONTFAMILY_EBGARAMOND",
  Georgia: "FONTFAMILY_GEORGIA",
  Helvetica: "FONTFAMILY_HELVETICA",
  Inter: "FONTFAMILY_INTER",
  Kalam: "FONTFAMILY_KALAM",
  Lato: "FONTFAMILY_LATO",
  Montserrat: "FONTFAMILY_MONTSERRAT",
  "Open Sans": "FONTFAMILY_OPENSANS",
  Oswald: "FONTFAMILY_OSWALD",
  "Playfair Display": "FONTFAMILY_PLAYFAIRDISPLAY",
  Poppins: "FONTFAMILY_POPPINS",
  Raleway: "FONTFAMILY_RALEWAY",
  Roboto: "FONTFAMILY_ROBOTO",
  "Roboto Condensed": "FONTFAMILY_ROBOTOCONDENSED",
  "Times New Roman": "FONTFAMILY_TIMESNEWROMAN",
  "Titillium Web": "FONTFAMILY_TITILLIUMWEB",
};

export const FONT_WEIGHT_OPTIONS = {
  FONTWEIGHT_LIGHT: {
    fontWeight: "300",
    fontWeightName: "Light",
  },
  FONTWEIGHT_REGULAR: {
    fontWeight: "400",
    fontWeightName: "Regular",
  },
  FONTWEIGHT_MEDIUM: {
    fontWeight: "500",
    fontWeightName: "Medium",
  },
  FONTWEIGHT_SEMIBOLD: {
    fontWeight: "600",
    fontWeightName: "Semibold",
  },
  FONTWEIGHT_BOLD: {
    fontWeight: "700",
    fontWeightName: "Bold",
  },
  FONTWEIGHT_EXTRABOLD: {
    fontWeight: "900",
    fontWeightName: "Extrabold",
  },
};

export const FONT_WEIGHT_OPTIONS_MAP = {
  "300": "FONTWEIGHT_LIGHT",
  "400": "FONTWEIGHT_REGULAR",
  "500": "FONTWEIGHT_MEDIUM",
  "600": "FONTWEIGHT_SEMIBOLD",
  "700": "FONTWEIGHT_BOLD",
  "900": "FONTWEIGHT_EXTRABOLD",
};

export const FONT_STYLE_SIZE_CONFIGS = {
  Light: {
    fontWeight: "300",
  },
  Regular: {
    fontWeight: "400",
  },
  Medium: {
    fontWeight: "500",
  },
  Semibold: {
    fontWeight: "600",
  },
  Bold: {
    fontWeight: "700",
  },
  Extrabold: {
    fontWeight: "900",
  },
};

export const CLOSEST_FONT_WEIGHT_OPTIONS = {
  FONTWEIGHT_LIGHT: ["FONTWEIGHT_LIGHT", "FONTWEIGHT_REGULAR"],
  FONTWEIGHT_REGULAR: ["FONTWEIGHT_REGULAR"],
  FONTWEIGHT_MEDIUM: ["FONTWEIGHT_MEDIUM", "FONTWEIGHT_REGULAR"],
  FONTWEIGHT_SEMIBOLD: [
    "FONTWEIGHT_SEMIBOLD",
    "FONTWEIGHT_BOLD",
    "FONTWEIGHT_EXTRABOLD",
  ],
  FONTWEIGHT_BOLD: [
    "FONTWEIGHT_BOLD",
    "FONTWEIGHT_EXTRABOLD",
    "FONTWEIGHT_SEMIBOLD",
  ],
  FONTWEIGHT_EXTRABOLD: [
    "FONTWEIGHT_EXTRABOLD",
    "FONTWEIGHT_BOLD",
    "FONTWEIGHT_SEMIBOLD",
  ],
};

export const FONT_WEIGHT_MAP = {
  Light: {
    style: "FONTWEIGHT_LIGHT",
    name: "Light",
    fontWeight: "300",
  },
  Regular: {
    style: "FONTWEIGHT_REGULAR",
    name: "Regular",
    fontWeight: "400",
  },
  Medium: {
    style: "FONTWEIGHT_MEDIUM",
    name: "Medium",
    fontWeight: "500",
  },
  Semibold: {
    style: "FONTWEIGHT_SEMIBOLD",
    name: "Semibold",
    fontWeight: "600",
  },
  Bold: {
    style: "FONTWEIGHT_BOLD",
    name: "Bold",
    fontWeight: "700",
  },
  Extrabold: {
    style: "FONTWEIGHT_EXTRABOLD",
    name: "Extrabold",
    fontWeight: "900",
  },
};

export const FONT_FAMILY_WEIGHT_MAPPING = {
  Arial: [],
  Baskerville: [FONT_WEIGHT_MAP.Regular, FONT_WEIGHT_MAP.Bold],
  "Courier New": [],
  "EB Garamond": [
    FONT_WEIGHT_MAP.Regular,
    FONT_WEIGHT_MAP.Medium,
    FONT_WEIGHT_MAP.Semibold,
    FONT_WEIGHT_MAP.Bold,
  ],
  Georgia: [],
  Helvetica: [],
  Inter: [
    FONT_WEIGHT_MAP.Light,
    FONT_WEIGHT_MAP.Regular,
    FONT_WEIGHT_MAP.Medium,
    FONT_WEIGHT_MAP.Semibold,
    FONT_WEIGHT_MAP.Bold,
    FONT_WEIGHT_MAP.Extrabold,
  ],
  Kalam: [FONT_WEIGHT_MAP.Light, FONT_WEIGHT_MAP.Regular, FONT_WEIGHT_MAP.Bold],
  Lato: [
    FONT_WEIGHT_MAP.Light,
    FONT_WEIGHT_MAP.Regular,
    FONT_WEIGHT_MAP.Bold,
    FONT_WEIGHT_MAP.Extrabold,
  ],
  Montserrat: [
    FONT_WEIGHT_MAP.Light,
    FONT_WEIGHT_MAP.Regular,
    FONT_WEIGHT_MAP.Medium,
    FONT_WEIGHT_MAP.Semibold,
    FONT_WEIGHT_MAP.Bold,
    FONT_WEIGHT_MAP.Extrabold,
  ],
  "Open Sans": [
    FONT_WEIGHT_MAP.Light,
    FONT_WEIGHT_MAP.Regular,
    FONT_WEIGHT_MAP.Semibold,
    FONT_WEIGHT_MAP.Bold,
  ],
  Oswald: [
    FONT_WEIGHT_MAP.Light,
    FONT_WEIGHT_MAP.Regular,
    FONT_WEIGHT_MAP.Medium,
    FONT_WEIGHT_MAP.Semibold,
    FONT_WEIGHT_MAP.Bold,
  ],
  "Playfair Display": [
    FONT_WEIGHT_MAP.Regular,
    FONT_WEIGHT_MAP.Medium,
    FONT_WEIGHT_MAP.Semibold,
    FONT_WEIGHT_MAP.Bold,
    FONT_WEIGHT_MAP.Extrabold,
  ],
  Poppins: [
    FONT_WEIGHT_MAP.Light,
    FONT_WEIGHT_MAP.Regular,
    FONT_WEIGHT_MAP.Medium,
    FONT_WEIGHT_MAP.Semibold,
    FONT_WEIGHT_MAP.Bold,
    FONT_WEIGHT_MAP.Extrabold,
  ],
  Raleway: [
    FONT_WEIGHT_MAP.Light,
    FONT_WEIGHT_MAP.Regular,
    FONT_WEIGHT_MAP.Medium,
    FONT_WEIGHT_MAP.Semibold,
    FONT_WEIGHT_MAP.Bold,
    FONT_WEIGHT_MAP.Extrabold,
  ],
  Roboto: [
    FONT_WEIGHT_MAP.Light,
    FONT_WEIGHT_MAP.Regular,
    FONT_WEIGHT_MAP.Medium,
    FONT_WEIGHT_MAP.Bold,
    FONT_WEIGHT_MAP.Extrabold,
  ],
  "Roboto Condensed": [
    FONT_WEIGHT_MAP.Light,
    FONT_WEIGHT_MAP.Regular,
    FONT_WEIGHT_MAP.Bold,
  ],
  "Times New Roman": [],
  "Titillium Web": [
    FONT_WEIGHT_MAP.Light,
    FONT_WEIGHT_MAP.Regular,
    FONT_WEIGHT_MAP.Semibold,
    FONT_WEIGHT_MAP.Bold,
    FONT_WEIGHT_MAP.Extrabold,
  ],
};

export const FONT_COLORS = [
  "#ffffff",
  "#000000",
  "#333333",
  "#888888",
  "#3333ff",
  "#66ccff",
  "#ff001c",
  "#faff00",
  "#9cd326",
  "#427d50",
  "#72c9c5",
  "#9dacbb",
  "#9795ff",
  "#7053c9",
  "#740e0e",
  "#ff0078",
  "#795449",
  "#e26d3f",
  "#f1cb45",
  "#bea938",
  "#99218d",
  "#8c39f0",
  "#0a269a",
  "#1f3e57",
  "#def8f6",
  "#cfd4d9",
  "#c12928",
];

export const EDITOR_CUSTOM_STYLES_MAP = {
  ...FONT_SIZE_OPTIONS,
  ...FONT_WEIGHT_OPTIONS,
  ...FONT_COLOR_OPTIONS,
  ...FONT_FAMILY_OPTIONS,
  ...FONT_STYLE_SIZE_CONFIGS,
  ...FONT_FAMILY_OPTIONS_MAP,
  BOLD: {
    "font-weight": "bold",
  },
  ITALIC: {
    "font-style": "italic",
  },
  UNDERLINE: {
    "text-decoration": "underline",
  },
};

export const UNDO_REDO_STACK_LIMIT = 50;

export const STACK_IGNORE_LIST = [
  DOCUMENT_COMPONENT_TYPES.DEAL_TABLE,
  DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE,
  DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET,
  DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE_WRAPPER,
];
export const DOCUMENT_ZOOM_CONFIGS = {
  "50": {
    prev: null,
    current: "50",
    next: "65",
  },
  "65": {
    prev: "50",
    current: "65",
    next: "75",
  },
  "75": {
    prev: "65",
    current: "75",
    next: "80",
  },
  "80": {
    prev: "75",
    current: "80",
    next: "90",
  },
  "90": {
    prev: "80",
    current: "90",
    next: "100",
  },
  "100": {
    prev: "90",
    current: "100",
    next: "110",
  },
  "110": {
    prev: "100",
    current: "110",
    next: "125",
  },
  "125": {
    prev: "110",
    current: "125",
    next: "150",
  },
  "150": {
    prev: "125",
    current: "150",
    next: null,
  },
};

export const DOCUMENT_DEFAULT_BG_COLOR = "lynch";
export const DOCUMENT_BG_COLORS = [
  "lynch",
  "cindrella",
  "sail-blue",
  "aquamarine",
  "antiquewhite",
  "burlywood",
  "quasar-gold",
  "nebula-purple",
  "flamingo-pink",
  "new-teal",
  "cerulean-blue",
  "emerald-green",
  "darkseagreen",
  "darkgray",
  "black",
];

export const DOCUMENT_BG_PATTERNS = [
  "ptrn-leaves",
  "patrn-dots",
  "patrn-triangle",
  "patrn-checked",
  "ptrn-floral",
  "patrn-memphis",
  "ptrn-wheat",
  "ptrn-spikes",
  "patrn-plant",
  "ptrn-trees",
  "patrn-serious",
  "patrn-circle",
  "ptrn-oriental",
  "ptrn-abstract",
  "ptrn-bananas",
];

export const DOCUMENT_SECTION_PLUS_BUTTON_BLOCKS = [
  // "top",
  "right",
  "bottom",
  "left",
];
const TRBL_POSITIONS = ["top", "right", "bottom", "left"];
const TB_POSITIONS = ["top", "bottom"];
const LR_POSITIONS = ["left", "right"];

export const POSITION_WISE_DOC_SECTION_PLUS_BUTTON_PLACEHOLDER = {
  ROW: {
    "empty-doc": ["top"],
    general: TB_POSITIONS,
  },
  COLUMN: {
    "left-right": LR_POSITIONS,
    general: LR_POSITIONS,
  },
};

export const POSITION_WISE_DOC_SECTION_DROP_PLACEHOLDER = {
  ROW: {
    "empty-doc": ["top"],
    general: TB_POSITIONS,
  },
  COLUMN: {
    "left-right": LR_POSITIONS,
    general: LR_POSITIONS,
  },
};

export const SECTION_AND_POSITION_WISE_PLACEHOLDER = {
  [DOCUMENT_COMPONENT_TYPES.HTML]: {
    BODY: TRBL_POSITIONS,
    COVERPAGE: TRBL_POSITIONS,
    HEADER: TRBL_POSITIONS,
    FOOTER: TRBL_POSITIONS,
  },
  [DOCUMENT_COMPONENT_TYPES.TABLE]: {
    BODY: TRBL_POSITIONS,
    COVERPAGE: TRBL_POSITIONS,
    HEADER: TRBL_POSITIONS,
    FOOTER: TRBL_POSITIONS,
  },
  [DOCUMENT_COMPONENT_TYPES.IMAGE]: {
    BODY: TRBL_POSITIONS,
    COVERPAGE: TRBL_POSITIONS,
    HEADER: TRBL_POSITIONS,
    FOOTER: TRBL_POSITIONS,
  },
  [DOCUMENT_COMPONENT_TYPES.DEAL_TABLE]: {
    BODY: TB_POSITIONS,
    COVERPAGE: [],
    HEADER: [],
    FOOTER: [],
  },
  [DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE]: {
    BODY: TB_POSITIONS,
    COVERPAGE: [],
    HEADER: [],
    FOOTER: [],
  },
  [DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE_WRAPPER]: {
    BODY: TB_POSITIONS,
    COVERPAGE: [],
    HEADER: [],
    FOOTER: [],
  },
  [DOCUMENT_COMPONENT_TYPES.EMPTY_CONTAINER]: {
    BODY: [],
    COVERPAGE: [],
    HEADER: [],
    FOOTER: [],
  },
  [DOCUMENT_COMPONENT_TYPES.EMPTY_SIGNATURE_CONTAINER]: {
    BODY: TRBL_POSITIONS,
    COVERPAGE: [],
    HEADER: [],
    FOOTER: [],
  },
  [DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET]: {
    BODY: TB_POSITIONS,
    COVERPAGE: [],
    HEADER: [],
    FOOTER: [],
  },
  [DOCUMENT_COMPONENT_TYPES.PAGE_BREAK]: {
    BODY: TB_POSITIONS,
    COVERPAGE: [],
    HEADER: [],
    FOOTER: [],
  },
  [DOCUMENT_COMPONENT_TYPES.LINE_SPACE]: {
    BODY: TB_POSITIONS,
    COVERPAGE: TB_POSITIONS,
    HEADER: TB_POSITIONS,
    FOOTER: TB_POSITIONS,
  },
  [DOCUMENT_COMPONENT_TYPES.STRIPE_PAYMENT_BUTTON]: {
    BODY: TRBL_POSITIONS,
    COVERPAGE: [],
    HEADER: [],
    FOOTER: [],
  },
};

export const SECTION_AND_POSITION_WISE_DOCUMENT_BLOCKS = {
  "add-text": {
    BODY: TRBL_POSITIONS,
    COVERPAGE: TRBL_POSITIONS,
    HEADER: TRBL_POSITIONS,
    FOOTER: TRBL_POSITIONS,
  },
  "add-table": {
    BODY: TRBL_POSITIONS,
    COVERPAGE: TRBL_POSITIONS,
    HEADER: TRBL_POSITIONS,
    FOOTER: TRBL_POSITIONS,
  },
  "add-image": {
    BODY: TRBL_POSITIONS,
    COVERPAGE: TRBL_POSITIONS,
    HEADER: TRBL_POSITIONS,
    FOOTER: TRBL_POSITIONS,
  },
  "add-dealtable": {
    BODY: TB_POSITIONS,
    COVERPAGE: [],
    HEADER: [],
    FOOTER: [],
  },
  "add-quotetable-placeholder": {
    BODY: TB_POSITIONS,
    COVERPAGE: [],
    HEADER: [],
    FOOTER: [],
  },
  "add-signature-space": {
    BODY: TRBL_POSITIONS,
    COVERPAGE: [],
    HEADER: [],
    FOOTER: [],
  },
  "add-google-sheet": {
    BODY: TB_POSITIONS,
    COVERPAGE: [],
    HEADER: [],
    FOOTER: [],
  },
  "add-page-break": {
    BODY: TB_POSITIONS,
    COVERPAGE: [],
    HEADER: [],
    FOOTER: [],
  },
  "add-line-space": {
    BODY: TB_POSITIONS,
    COVERPAGE: TB_POSITIONS,
    HEADER: ["top", "bottom"],
    FOOTER: ["top", "bottom"],
  },
  "add-payment-button": {
    BODY: TRBL_POSITIONS,
    COVERPAGE: [],
    HEADER: [],
    FOOTER: [],
  },
};

export const FORM_FIELDS_DEFAULT_VALUES = {
  PERIOD: { periodUom: "", periodValue: "" },
  ADDRESS: {
    addressLineOne: "",
    addressLineTwo: "",
    city: "",
    country: "",
    state: "",
    zip: "",
  },
  PERSONNAME: { firstName: "", lastName: "" },
};

export const ESIGN_EMPTY_PAYLOAD = {
  first_name: "",
  last_name: "",
  signer_email: "",
  type: "Signature",
  signer_type_config: [
    {
      label: "Click to Sign",
      value: "Click to Sign",
      selected: true,
    },
    {
      label: "Draw Signature",
      value: "Draw Signature",
      selected: false,
    },
    {
      label: "Click to Initial",
      value: "Click to Initial",
      selected: false,
    },
  ],
  signer_config: {
    signature_type: "FULLNAME",
    point: {
      x: 0,
      y: 0,
      page_no: 0,
    },
    options: [
      {
        checked: true,
        id: "signature",
        label: "Signature",
        value: "",
        width: 200,
        height: 60,
      },
      {
        checked: false,
        id: "name",
        label: "Signer Name",
        value: "",
        width: 200,
        height: 60,
      },
      {
        checked: false,
        id: "date",
        label: "Signing Date",
        value: "",
        width: 200,
        height: 60,
      },
    ],
  },
};

export const ESIGN_TYPE = {
  "Click to Sign": "Signer's full name will be captured as the signature",
  "Draw Signature": "Draw Signature",
  "Click to Initial": "Signer's initials will be captured as the signature",
};

export const ESIGN_TYPE_CONFIG = [
  {
    label: "Click to Sign",
    sublabel: "Signer's full name will be captured as the signature",
    value: "FULLNAME",
  },
  {
    label: "Draw Signature",
    sublabel: "Draw Signature",
    value: "CAPTURE",
  },
  {
    label: "Click to Initial",
    sublabel: "Signer's initials will be captured as the signature",
    value: "INITIALS",
  },
];



// WEBPACK FOOTER //
// ./src/constants/document.js